<template>
  <div class="chat-box">
    <!-- video chat start -->
    <video-call-overlay />
    <video-call v-if="$store.state.videoChat.display_video_chat" />
    <!-- video chat end -->
    <div v-show="!$store.state.videoChat.display_video_chat" class="chat-box-header">
      <div class="box-header-1" style="width: 100%;">
        <template v-if="Object.keys($store.state.config.steps).length
      && !no_chat
      && $store.state.config.details.display != 'manfield'
      && $store.state.config.storeId != 16
      && $store.state.config.storeId != 41
      && $store.state.config.storeId != 46
      && $store.state.config.storeId != 35
      && $store.state.config.storeId != 20
      && $store.state.config.storeId != 25
      && $store.state.config.storeId != 36
      && $store.state.config.storeId != 50
      && $store.state.config.storeId != 43
      && $store.state.config.storeId != 47
      && $store.state.config.storeId != 49
      && $store.state.config.storeId != 51
      && $store.state.config.storeId != 52
      && $store.state.config.storeId != 53
      && $store.state.config.storeId != 54
      && $store.state.config.storeId != 55
      && $store.state.config.storeId != 56
      && $store.state.config.storeId != 57
      && $store.state.config.storeId != 59
      && $store.state.config.storeId != 78
      && $store.state.config.storeId != 79
      && $store.state.config.storeId != 88
      && $store.state.config.storeId != 87
      && $store.state.config.storeId != 89
      && $store.state.config.storeId != 90
      && $store.state.config.storeId != 95
      && $store.state.config.storeId != 97
      && $store.state.config.storeId != 96
      && $store.state.config.storeId != 98




      ">
          <div v-if="$store.state.user.style_profile_resume" class="chat-box-switch-mode"
            @click="change_mode(null, 'style_profile')">
            <i class="material-icons chat-box-menu-button big"
              :title="$t('popup.proposition4')">star_border<!-- recent_actors--></i>
          </div>
          <div v-else-if="$store.state.user.style_profile" class="chat-box-switch-mode"
            @click="change_mode('', 'chat')">
            <i class="material-icons chat-box-menu-button big" :title="$t('popup.proposition2')">chat_bubble</i>
          </div>
          <div v-else-if="$store.state.user.style_profile_resume == false && $store.state.user.style_profile == false"
            class="chat-box-switch-mode" @click="change_mode(null, 'style_profile')">
            <i class="material-icons chat-box-menu-button big" :title="$t('popup.proposition4')">star_border</i>
          </div>
        </template>
        <!-- Bouton home -->
        <div
          v-if="$store.state.config.storeId == 38 || $store.state.config.storeId == 40 || $store.state.config.storeId == 36 || $store.state.config.storeId == 41 || $store.state.config.storeId == 35 || $store.state.config.storeId == 46 || $store.state.config.storeId == 25 || $store.state.config.storeId == 36 || $store.state.config.storeId == 50 || $store.state.config.storeId == 43 || $store.state.config.storeId == 47 || $store.state.config.storeId == 51 || $store.state.config.storeId == 53 || $store.state.config.storeId == 88"
          class="chat-box-switch-mode" @click="onRestart">
          <i class="material-icons chat-box-menu-button big" :title="$t('nomore.restart')">home</i>
        </div>
        <!-- Bouton home - avec un style top:0 / exception - exception 2 - exception staging - manfield -->
        <div
          v-if="$store.state.config.storeId == 28 || $store.state.config.storeId == 37 || $store.state.config.storeId == 33 || $store.state.config.storeId == 20 || $store.state.config.storeId == 59"
          class="chat-box-switch-mode" style="top: 0px;" @click="onRestart">
          <i class="material-icons chat-box-menu-button big" :title="$t('nomore.restart')">home</i>
        </div>
        <!-- Bouton home pour cleed.com -->
        <div
          v-if="$store.state.config.storeId == 48 || $store.state.config.storeId == 49 || $store.state.config.storeId == 54 || $store.state.config.storeId == 52 || $store.state.config.storeId == 55 || $store.state.config.storeId == 56 || $store.state.config.storeId == 57 || $store.state.config.storeId == 78 || $store.state.config.storeId == 79 || $store.state.config.storeId == 89 || $store.state.config.storeId == 90 || $store.state.config.storeId == 95 || $store.state.config.storeId == 96 || $store.state.config.storeId == 97 || $store.state.config.storeId == 98"
          class="chat-box-switch-mode" @click="toggleAppVisibility">
          <i class="material-icons chat-box-menu-button big" :title="$t('nomore.restart')">home</i>
        </div>
        <div v-if="$store.state.config.storeId == 87" class="chat-box-switch-mode chat-box-switch-mode-mfk"
          @click="onRestart">
          <i class="material-icons chat-box-menu-button big" :title="$t('nomore.restart')">replay</i>
        </div>


        <!--<div class="chat-box-back" @click="$eb.emit('BoxBack')">
        <i class="material-icons reverse chat-box-menu-button">arrow_forward_ios</i>
      </div>-->


        <div class="box-header-title">
          <!-- Titre h1 max -->
          <div class="header-box-title">
            <h1
              v-if="$store.state.config.details.display != 'manfield' && $store.state.config.storeId != 25 && $store.state.config.storeId != 20 && $store.state.config.storeId != 50"
              style="margin-bottom: 0.5em; margin-top: 0.7em;">
              {{ $t(title) }}
            </h1>
            <!-- Titre h1 max-1 -->
            <h1 v-if="$store.state.config.storeId == 25"
              style="margin-bottom: 0.5em; margin-top: 0.7em; font-size: 22px;">
              {{ $t(title) }}
            </h1>
            <!-- Titre h1 à gauche (Manfield) -->
            <h1 v-if="$store.state.config.storeId == 20" style="font-family: avenir next medium; font-size: 19px;">
              {{ $t(title) }}
            </h1>
            <!-- Titre h1 max-2 -->
            <h1
              v-if="$store.state.config.storeId == 50 || $store.state.config.storeId == 38 || $store.state.config.storeId == 40"
              style="margin-bottom: 0.5em; margin-top: 0.7em; font-family: 'Helvetica Neue', 'Muli Bold', 'Muli'; font-size: 20px;">
              {{ $t(title) }}
            </h1>
          </div>
          <div class="header-box-sub-title">
            <div class="_online_icon">
              <!-- Bouton vert - normal -->
              <span
                v-if="($store.state.config.storeId == 38 || $store.state.config.storeId == 40 || $store.state.config.storeId == 47 || $store.state.config.storeId == 46 || $store.state.config.storeId == 18 || $store.state.config.storeId == 36 || $store.state.config.storeId == 23 || $store.state.config.storeId == 42 || $store.state.config.storeId == 41 || $store.state.config.storeId == 35 || $store.state.config.storeId == 49 || $store.state.config.storeId == 50 || $store.state.config.storeId == 43 || $store.state.config.storeId == 51 || $store.state.config.storeId == 52 || $store.state.config.storeId == 53 || $store.state.config.storeId == 54 || $store.state.config.storeId == 55 || $store.state.config.storeId == 56 || $store.state.config.storeId == 57 || $store.state.config.storeId == 78 || $store.state.config.storeId == 79 || $store.state.config.storeId == 88 || $store.state.config.storeId == 89 || $store.state.config.storeId == 90  || $store.state.config.storeId == 95 || $store.state.config.storeId == 96 || $store.state.config.storeId == 97 || $store.state.config.storeId == 98) && $store.state.config.chat_config.chat_state.state == 'active' && !$store.state.videoChat.GetCall"
                class="green-circle-box" style="display: block; margin-left: 41%;"></span>
              <!-- <span v-if="($store.state.config.storeId == 47 || $store.state.config.storeId == 46 || $store.state.config.storeId == 35 || $store.state.config.storeId == 18 || $store.state.config.storeId == 36 || $store.state.config.storeId == 23 || $store.state.config.storeId == 42 || $store.state.config.storeId == 41) && $store.state.config.chat_config.chat_state.state == 'not_reactive'" class="green-circle-box" style="left: 85px;"></span> -->
              <!-- Bouton vert - fete imperial -->
              <span
                v-if="$store.state.config.storeId == 25 && $store.state.config.chat_config.chat_state.state == 'active'"
                class="green-circle-box" style="left: 172px; top:48px;"></span>
              <!-- <span v-if="$store.state.config.storeId == 25 && $store.state.config.chat_config.chat_state.state == 'not_reactive'" class="green-circle-box" style="left: 85px; top:48px;"></span> -->

            </div>
            <div class="_status">
              <!-- Statut max -->
              <h5
                v-if="($store.state.config.storeId == 38 || $store.state.config.storeId == 40 || $store.state.config.storeId == 43 || $store.state.config.storeId == 48 || $store.state.config.storeId == 47 || $store.state.config.storeId == 46 || $store.state.config.storeId == 18 || $store.state.config.storeId == 25 || $store.state.config.storeId == 36 || $store.state.config.storeId == 23 || $store.state.config.storeId == 42 || $store.state.config.storeId == 41 || $store.state.config.storeId == 49 || $store.state.config.storeId == 50 || $store.state.config.storeId == 51 || $store.state.config.storeId == 52 || $store.state.config.storeId == 53 || $store.state.config.storeId == 54 || $store.state.config.storeId == 55 || $store.state.config.storeId == 56 || $store.state.config.storeId == 57 || $store.state.config.storeId == 78 || $store.state.config.storeId == 79 || $store.state.config.storeId == 88 || $store.state.config.storeId == 89 || $store.state.config.storeId == 90  || $store.state.config.storeId == 95 || $store.state.config.storeId == 96 || $store.state.config.storeId == 97 || $store.state.config.storeId == 98) && $store.state.config.chat_config.chat_state.state == 'active'"
                style="margin-top: 0; margin-bottom: 1.4em; font-size: 67%;">
                {{ $t('status.here') }}
              </h5>
              <!-- Statut max-1 -->
              <h5
                v-if="$store.state.config.storeId == 35 && $store.state.config.chat_config.chat_state.state == 'active'"
                style="margin-top: 0; margin-bottom: 1.4em; font-size: 60%;">
                {{ $t('status.here') }}
              </h5>
              <!-- Statut - attente réponse humaine -->
              <h5
                v-else-if="($store.state.config.storeId == 38 || $store.state.config.storeId == 40 || $store.state.config.storeId == 43 || $store.state.config.storeId == 48 || $store.state.config.storeId == 47 || $store.state.config.storeId == 46 || $store.state.config.storeId == 35 || $store.state.config.storeId == 18 || $store.state.config.storeId == 25 || $store.state.config.storeId == 36 || $store.state.config.storeId == 23 || $store.state.config.storeId == 42 || $store.state.config.storeId == 41 || $store.state.config.storeId == 49 || $store.state.config.storeId == 50 || $store.state.config.storeId == 51 || $store.state.config.storeId == 52 || $store.state.config.storeId == 53 || $store.state.config.storeId == 54 || $store.state.config.storeId == 55 || $store.state.config.storeId == 56 || $store.state.config.storeId == 57 || $store.state.config.storeId == 78 || $store.state.config.storeId == 79 || $store.state.config.storeId == 88 || $store.state.config.storeId == 89 || $store.state.config.storeId == 90 || $store.state.config.storeId == 95 || $store.state.config.storeId == 96 || $store.state.config.storeId == 97 || $store.state.config.storeId == 98) && $store.state.config.chat_config.chat_state.state == 'not_reactive'"
                style="margin-top: 0; margin-bottom: 1.4em; font-size: 67%;">
                {{ $t('status.not_reactive') }}
              </h5>
              <!-- Statut - laisser un message -->
              <h5
                v-else-if="($store.state.config.storeId == 38 || $store.state.config.storeId == 40 || $store.state.config.storeId == 43 || $store.state.config.storeId == 48 || $store.state.config.storeId == 47 || $store.state.config.storeId == 46 || $store.state.config.storeId == 35 || $store.state.config.storeId == 18 || $store.state.config.storeId == 25 || $store.state.config.storeId == 36 || $store.state.config.storeId == 23 || $store.state.config.storeId == 42 || $store.state.config.storeId == 41 || $store.state.config.storeId == 49 || $store.state.config.storeId == 50 || $store.state.config.storeId == 51 || $store.state.config.storeId == 52 || $store.state.config.storeId == 53 || $store.state.config.storeId == 54 || $store.state.config.storeId == 55 || $store.state.config.storeId == 56 || $store.state.config.storeId == 57 || $store.state.config.storeId == 78 || $store.state.config.storeId == 79 || $store.state.config.storeId == 88 || $store.state.config.storeId == 89 || $store.state.config.storeId == 90 || $store.state.config.storeId == 95 || $store.state.config.storeId == 96 || $store.state.config.storeId == 97 || $store.state.config.storeId == 98) && $store.state.config.chat_config.chat_state.state != 'not_reactive' && $store.state.config.chat_config.chat_state.state != 'active'"
                style="margin-top: 0; margin-bottom: 1.4em; font-size: 67%;">
                {{ $t('status.not_here') }}
              </h5>
            </div>


          </div>
        </div>

        <!-- Ancien menu de navigation -->
        <div
          v-if="$store.state.config.storeId == 16 || $store.state.config.details.display == 'manfield' && $store.state.config.storeId != 38 && $store.state.config.storeId != 40"
          :class="$store.state.config.storeId == 16 ? 'chat-switch-style-profile' : 'chat-switch-style-profile-manfield'">
          <!-- Button order for all stores except ***** -->
          <button v-if="$store.state.config.storeId != 35 && $store.state.config.storeId != 20"
            :class="$store.state.config.details.display == 'manfield' ? (navigation_mode === 'style_profile' ? 'disable-button-manfield' : 'active-button-manfield') : (navigation_mode === 'style_profile' ? 'disable-button' : '')"
            @click="change_mode(null, 'style_profile')">
            {{ $t('chat.shopping_assistant') }}
          </button>

          <button v-if="$store.state.config.storeId != 35 && $store.state.config.storeId != 20"
            :class="$store.state.config.details.display == 'manfield' ? (navigation_mode === 'chat' ? 'disable-button-manfield' : 'active-button-manfield') : (navigation_mode === 'chat' ? 'disable-button' : '')"
            @click="change_mode('', 'chat')">
            {{ $t('chat.customer_service') }}
          </button>

          <!-- Button order for store  ***** -->
          <button v-if="$store.state.config.storeId == 35 || $store.state.config.storeId == 20"
            :class="$store.state.config.details.display == 'manfield' ? (navigation_mode === 'chat' ? 'disable-button-manfield' : 'active-button-manfield') : (navigation_mode === 'chat' ? 'disable-button' : '')"
            @click="change_mode('', 'chat')">
            {{ $t('chat.customer_service') }}
          </button>

          <button v-if="$store.state.config.storeId == 35 || $store.state.config.storeId == 20"
            :class="$store.state.config.details.display == 'manfield' ? (navigation_mode === 'style_profile' ? 'disable-button-manfield' : 'active-button-manfield') : (navigation_mode === 'style_profile' ? 'disable-button' : '')"
            @click="change_mode(null, 'style_profile')">
            {{ $t('chat.shopping_assistant') }}
          </button>

          <button v-if="$store.state.config.details.search_display || $store.state.config.storeId == 35"
            :class="navigation_mode != 'search' ? 'active-button-manfield' : 'disable-button-manfield'"
            @click="change_mode($t('text.looking_for_product'), 'search')">
            {{ $t('text.searches') }}
          </button>

          <!-- <div class="notifications_button">
          <i v-if="$store.state.navigation.notificationSound" class="material-icons chat-box-menu-button" style="margin-right: 0px;" @click="change_notif_mode()">notifications</i>
          <i v-else class="material-icons chat-box-menu-button" style="margin-right: 0px;" @click="change_notif_mode()">notifications_off</i>
        </div> -->
        </div>

        <!-- Bouton pour fermer la box -->
        <div class="chat-box-actions">
          <!-- Bouton de notification -->
          <div
            v-if="$store.state.config.storeId == 38 || $store.state.config.storeId == 40 || $store.state.config.storeId == 43 || $store.state.config.storeId == 48 || $store.state.config.storeId == 47 || $store.state.config.storeId == 46 || $store.state.config.storeId == 35 || $store.state.config.storeId == 18 || $store.state.config.storeId == 25 || $store.state.config.storeId == 36 || $store.state.config.storeId == 23 || $store.state.config.storeId == 42 || $store.state.config.storeId == 41 || $store.state.config.storeId == 50 || $store.state.config.storeId == 51 || $store.state.config.storeId == 52 || $store.state.config.storeId == 53 || $store.state.config.storeId == 54 || $store.state.config.storeId == 55 || $store.state.config.storeId == 56 || $store.state.config.storeId == 57 || $store.state.config.storeId == 78 || $store.state.config.storeId == 79 || $store.state.config.storeId == 88 || $store.state.config.storeId == 89 || $store.state.config.storeId == 90 || $store.state.config.storeId == 95 || $store.state.config.storeId == 96 || $store.state.config.storeId == 97 || $store.state.config.storeId == 98"
            class="notifications_button" :style="{ 'left': $store.state.config.storeId == 50 ? '332px' : '' }">
            <i v-if="$store.state.navigation.notificationSound" class="material-icons chat-box-menu-button"
              style="margin-right: 0;" @click="change_notif_mode()">notifications</i>
            <i v-else class="material-icons chat-box-menu-button" style="margin-right: 0;"
              @click="change_notif_mode()">notifications_off</i>
          </div>

          <!-- Bouton de paramétrage cleed.com + bouton de notification -->
          <div v-if="$store.state.config.storeId == 49 || $store.state.config.storeId == 59" class="settings-dropdown"
            :style="$store.state.config.storeId == 59 ? { top: '-19px' } : {}">
            <i class="material-icons chat-box-menu-button" style="margin-right: 0;" @click="display_settings()">tune</i>
            <div v-if="settingsMenuOn" class="settings-dropdown-content">
              <div v-if="$store.state.config.storeId == 59">
                <a class="a-setting" @click="display_profile_page()">
                  <span class="span-setting">Mes préférences</span>
                  <i class="material-icons i-setting" style="margin-right: 0;">account_circle</i>
                </a>
                <a class="a-setting" @click="log_out()">
                  <span class="span-setting">Se déconnecter</span>
                  <i class="material-icons i-setting" style="margin-right: 0;">logout</i>
                </a>
              </div>
              <div v-else>
                <a class="a-setting" @click="change_notif_mode_dropdown()">
                  <span class="span-setting">Notifications</span>
                  <i v-if="$store.state.navigation.notificationSound" class="material-icons i-setting"
                    style="margin-right: 0;">notifications</i>
                  <i v-else class="material-icons i-setting" style="margin-right: 0;">notifications_off</i>
                </a>
              </div>
            </div>
          </div>
          <div
            :class="($store.state.config.details.display == 'manfield') && $store.state.config.storeId != 38 && $store.state.config.storeId != 40 ? 'chat-box-close-manfield' : $store.state.config.storeId == 87 ? 'chat-box-close-mfk' : 'chat-box-close-1'"
            :style="{ 'left': $store.state.config.storeId == 50 ? '372px' : '' }" @click="$eb.emit('BoxClose')">
            <i v-if="$store.state.config.storeId == 33" class="material-icons chat-box-menu-button"
              style="font-size: 40px; margin-left: 0; margin-top: 5px;">{{ close_icon }}</i>
            <i v-else-if="$store.state.config.storeId == 20" class="material-icons chat-box-menu-button"
              style="margin-left: 0; margin-top: 5px;">{{ close_icon }}</i>
            <i v-else class="material-icons chat-box-menu-button big" style="margin-left: 0;">{{ close_icon }}</i>
          </div>

        </div>

      </div>
    </div>

    <!-- top bar -->

    <TopBarGenAi v-show="$store.state.config.chatgpt === true && genai_tabs?.length > 1" :tabs="genai_tabs">
    </TopBarGenAi>
    <div v-if="$store.state.config.storeId == 59 && true" style="border:none;">
      <TimeTracker />
      <span v-if="this.profilePageOn">
        <ProfilePage :toggle="display_profile_page" />
      </span>
    </div>

    <div v-if="$store.state.config.storeId == 87" style="border:none;">
      <Topbar_mfk />
    </div>
    <!-- end top bar display -->
    <app-display v-if="$store.state.config.storeId == 49 && $store.state.config.appIsVisible"></app-display>
    <div v-show="!$store.state.videoChat.display_video_chat"
      v-else-if="($store.state.config.storeId != 49 || ($store.state.config.storeId == 49 && !$store.state.config.appIsVisible)) && !$store.state.session_navigation.modle3D && !$store.state.session_navigation.virtual"
      class="chat-box-body">
      <VEmojiPicker v-show="showDialog" class="chat-emojis" :i18n="i18n" label-search="Search" lang="pt-BR"
        @select="onSelectEmoji" />

      <search v-if="navigation_mode === 'search'"></search>
      <chat v-else-if="navigation_mode !== 'search' && !showDialog"
        :style="navigation_mode === 'style_profile' ? 'max-height: calc(100% - 24px)' : ''"></chat>
    </div>

    <iframe v-else-if="$store.state.config.storeId == 49 && $store.state.session_navigation.modle3D"
      class="chat-box-body" style="border:none" src="https://dist.unlimited3d.com/dists/dkny/black-hoodie/40400/57598">
    </iframe>

    <virtual v-else-if="$store.state.config.storeId == 49 && $store.state.session_navigation.virtual"
      class="chat-box-body" style="border:none">
    </virtual>

    <attachment-box></attachment-box>

    <nav-items
      v-if="$store.state.config.storeId == 49 && $store.state.config.appIsVisible === false && $store.state.session_navigation.virtual === false"></nav-items>


    <powered-by v-if="$store.state.config.storeId != 59" />
    <!-- <div v-if="!$store.state.videoChat.display_video_chat && $store.state.config.storeId != 49 || ($store.state.config.storeId == 49 && !$store.state.config.appIsVisible)" class="chat-box-footer" :style="(this.navigation_mode == 'chat' && ($store.state.navigation.countMessageSession >= 1 && $store.state.config.chat_config.chat_state.state == 'not_reactive')) || (this.navigation_mode == 'chat' && $store.state.config.chat_config.chat_state.state == 'active') ? '' : 'display: none'"> -->
    <div v-if="(!$store.state.videoChat.display_video_chat) &&
      ($store.state.config.storeId != 49 ||
        ($store.state.config.storeId == 49 && !$store.state.config.appIsVisible)) &&
      ($store.state.config.storeId != 87)"
      v-show="(this.navigation_mode == 'chat' && ($store.state.navigation.countMessageSession >= 1 && $store.state.config.chat_config.chat_state.state == 'not_reactive')) || (this.navigation_mode == 'chat' && $store.state.config.chat_config.chat_state.state == 'active')"
      class="chat-box-footer">
      <div class="footer-text">
        <!-- //NOTE: textarea disabled hold the input if chat gpt is not ready -->
        <textarea id="chat-input" v-model="chat_input" type="text" :placeholder="$t('chat.enter')"
          @keyup.enter.exact="submit()" @focus="input_focus()" @blur="input_blur()"
          :disabled="$store.state.user.loading_indicator" />
        <span>

        </span>
      </div>

      <div class="footer-buttons-group">
        <button v-if="$store.state.config.storeId != 46 && chat_input" style="fill: rgb(112 112 112);"
          @click="toogleDialogEmoji">
          <svg aria-hidden="true" role="img" width="24" height="24" preserveAspectRatio="xMidYMid meet"
            viewBox="0 0 24 24">
            <rect x="0" y="0" width="24" height="24" fill="none" stroke="none" />
            <g v-if="!showDialog">
              <path class="path-emoji"
                d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10a10 10 0 0 0 10-10c0-5.53-4.5-10-10-10m0 18a8 8 0 0 1-8-8a8 8 0 0 1 8-8a8 8 0 0 1 8 8a8 8 0 0 1-8 8m1-10.06L14.06 11l1.06-1.06L16.18 11l1.06-1.06l-2.12-2.12L13 9.94m-4.12 0L9.94 11L11 9.94L8.88 7.82L6.76 9.94L7.82 11l1.06-1.06M12 17.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
                fill-rule="evenodd" />
            </g>
            <g v-else>
              <path class="path-emoji"
                d="M 22.019531 2.289062 L 1.980469 2.289062 C 0.886719 2.289062 0 3.175781 0 4.265625 L 0 16.292969 C 0 17.382812 0.886719 18.269531 1.980469 18.269531 L 3.207031 18.269531 L 3.207031 20.933594 C 3.207031 21.25 3.394531 21.53125 3.6875 21.652344 C 3.78125 21.691406 3.882812 21.710938 3.984375 21.710938 C 4.1875 21.710938 4.382812 21.632812 4.53125 21.484375 L 7.746094 18.269531 L 22.019531 18.269531 C 23.113281 18.269531 24 17.382812 24 16.292969 L 24 4.265625 C 24 3.175781 23.113281 2.289062 22.019531 2.289062 Z M 23.25 16.292969 C 23.25 16.96875 22.699219 17.519531 22.019531 17.519531 L 7.589844 17.519531 C 7.492188 17.519531 7.394531 17.558594 7.324219 17.628906 L 4 20.953125 C 3.996094 20.960938 3.988281 20.964844 3.972656 20.957031 C 3.957031 20.953125 3.957031 20.945312 3.957031 20.9375 L 3.957031 17.894531 C 3.957031 17.6875 3.789062 17.519531 3.582031 17.519531 L 1.980469 17.519531 C 1.300781 17.519531 0.75 16.96875 0.75 16.292969 L 0.75 4.265625 C 0.75 3.589844 1.300781 3.039062 1.980469 3.039062 L 22.019531 3.039062 C 22.699219 3.039062 23.25 3.589844 23.25 4.265625 Z M 23.25 16.292969" />
              <path class="path-emoji"
                d="M 10.753906 13.773438 L 8.527344 6.71875 C 8.371094 6.226562 7.921875 5.894531 7.402344 5.894531 L 6.976562 5.894531 C 6.460938 5.894531 6.007812 6.226562 5.851562 6.71875 L 3.625 13.773438 C 3.5625 13.972656 3.671875 14.183594 3.871094 14.246094 C 4.066406 14.308594 4.277344 14.199219 4.339844 14 L 4.890625 12.257812 L 9.488281 12.257812 L 10.039062 14 C 10.089844 14.160156 10.238281 14.261719 10.398438 14.261719 C 10.433594 14.261719 10.472656 14.257812 10.511719 14.246094 C 10.707031 14.183594 10.816406 13.972656 10.753906 13.773438 Z M 5.128906 11.507812 L 6.570312 6.945312 C 6.625 6.765625 6.789062 6.648438 6.976562 6.648438 L 7.402344 6.648438 C 7.589844 6.648438 7.753906 6.765625 7.808594 6.945312 L 9.25 11.507812 Z M 5.128906 11.507812" />
              <path class="path-emoji"
                d="M 13.203125 9.503906 C 12.738281 9.503906 12.3125 9.664062 11.976562 9.929688 L 11.976562 6.671875 C 11.976562 6.464844 11.808594 6.296875 11.597656 6.296875 C 11.390625 6.296875 11.222656 6.464844 11.222656 6.671875 L 11.222656 12.285156 C 11.222656 13.375 12.109375 14.261719 13.203125 14.261719 C 14.515625 14.261719 15.582031 13.195312 15.582031 11.882812 C 15.582031 10.570312 14.515625 9.503906 13.203125 9.503906 Z M 13.203125 13.511719 C 12.527344 13.511719 11.976562 12.960938 11.976562 12.285156 L 11.976562 11.480469 C 11.976562 10.804688 12.527344 10.253906 13.203125 10.253906 C 14.101562 10.253906 14.832031 10.984375 14.832031 11.882812 C 14.832031 12.78125 14.101562 13.511719 13.203125 13.511719 Z M 13.203125 13.511719" />
              <path class="path-emoji"
                d="M 20.242188 12.785156 C 20.074219 12.660156 19.839844 12.695312 19.714844 12.859375 C 19.40625 13.273438 18.929688 13.511719 18.414062 13.511719 C 17.515625 13.511719 16.785156 12.78125 16.785156 11.882812 C 16.785156 10.984375 17.515625 10.253906 18.414062 10.253906 C 18.929688 10.253906 19.40625 10.492188 19.714844 10.90625 C 19.839844 11.074219 20.074219 11.105469 20.242188 10.980469 C 20.40625 10.855469 20.441406 10.621094 20.316406 10.457031 C 19.863281 9.851562 19.167969 9.503906 18.414062 9.503906 C 17.101562 9.503906 16.03125 10.570312 16.03125 11.882812 C 16.03125 13.195312 17.101562 14.261719 18.414062 14.261719 C 19.167969 14.261719 19.863281 13.914062 20.316406 13.3125 C 20.441406 13.144531 20.40625 12.910156 20.242188 12.785156 Z M 20.242188 12.785156" />
            </g>
          </svg>
        </button>
        <button v-if="chat_input && $store.state.config.storeId != 54" type="button" style="fill: rgb(112 112 112);"
          @click="toogleAttachmentBox">
          <span class="material-icons">attach_file</span>
        </button>
        <button v-if="$store.state.config.storeId == 46 && chat_input" style="fill: rgb(112 112 112);"
          @click="toogleDialogEmoji">
          <svg aria-hidden="true" role="img" width="24" height="24" preserveAspectRatio="xMidYMid meet"
            viewBox="0 0 24 24">
            <rect x="0" y="0" width="24" height="24" fill="none" stroke="none" />
            <g v-if="!showDialog">
              <path
                d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10a10 10 0 0 0 10-10c0-5.53-4.5-10-10-10m0 18a8 8 0 0 1-8-8a8 8 0 0 1 8-8a8 8 0 0 1 8 8a8 8 0 0 1-8 8m1-10.06L14.06 11l1.06-1.06L16.18 11l1.06-1.06l-2.12-2.12L13 9.94m-4.12 0L9.94 11L11 9.94L8.88 7.82L6.76 9.94L7.82 11l1.06-1.06M12 17.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
                fill-rule="evenodd" />
            </g>
            <g v-else>
              <path
                d="M 22.019531 2.289062 L 1.980469 2.289062 C 0.886719 2.289062 0 3.175781 0 4.265625 L 0 16.292969 C 0 17.382812 0.886719 18.269531 1.980469 18.269531 L 3.207031 18.269531 L 3.207031 20.933594 C 3.207031 21.25 3.394531 21.53125 3.6875 21.652344 C 3.78125 21.691406 3.882812 21.710938 3.984375 21.710938 C 4.1875 21.710938 4.382812 21.632812 4.53125 21.484375 L 7.746094 18.269531 L 22.019531 18.269531 C 23.113281 18.269531 24 17.382812 24 16.292969 L 24 4.265625 C 24 3.175781 23.113281 2.289062 22.019531 2.289062 Z M 23.25 16.292969 C 23.25 16.96875 22.699219 17.519531 22.019531 17.519531 L 7.589844 17.519531 C 7.492188 17.519531 7.394531 17.558594 7.324219 17.628906 L 4 20.953125 C 3.996094 20.960938 3.988281 20.964844 3.972656 20.957031 C 3.957031 20.953125 3.957031 20.945312 3.957031 20.9375 L 3.957031 17.894531 C 3.957031 17.6875 3.789062 17.519531 3.582031 17.519531 L 1.980469 17.519531 C 1.300781 17.519531 0.75 16.96875 0.75 16.292969 L 0.75 4.265625 C 0.75 3.589844 1.300781 3.039062 1.980469 3.039062 L 22.019531 3.039062 C 22.699219 3.039062 23.25 3.589844 23.25 4.265625 Z M 23.25 16.292969" />
              <path
                d="M 10.753906 13.773438 L 8.527344 6.71875 C 8.371094 6.226562 7.921875 5.894531 7.402344 5.894531 L 6.976562 5.894531 C 6.460938 5.894531 6.007812 6.226562 5.851562 6.71875 L 3.625 13.773438 C 3.5625 13.972656 3.671875 14.183594 3.871094 14.246094 C 4.066406 14.308594 4.277344 14.199219 4.339844 14 L 4.890625 12.257812 L 9.488281 12.257812 L 10.039062 14 C 10.089844 14.160156 10.238281 14.261719 10.398438 14.261719 C 10.433594 14.261719 10.472656 14.257812 10.511719 14.246094 C 10.707031 14.183594 10.816406 13.972656 10.753906 13.773438 Z M 5.128906 11.507812 L 6.570312 6.945312 C 6.625 6.765625 6.789062 6.648438 6.976562 6.648438 L 7.402344 6.648438 C 7.589844 6.648438 7.753906 6.765625 7.808594 6.945312 L 9.25 11.507812 Z M 5.128906 11.507812" />
              <path
                d="M 13.203125 9.503906 C 12.738281 9.503906 12.3125 9.664062 11.976562 9.929688 L 11.976562 6.671875 C 11.976562 6.464844 11.808594 6.296875 11.597656 6.296875 C 11.390625 6.296875 11.222656 6.464844 11.222656 6.671875 L 11.222656 12.285156 C 11.222656 13.375 12.109375 14.261719 13.203125 14.261719 C 14.515625 14.261719 15.582031 13.195312 15.582031 11.882812 C 15.582031 10.570312 14.515625 9.503906 13.203125 9.503906 Z M 13.203125 13.511719 C 12.527344 13.511719 11.976562 12.960938 11.976562 12.285156 L 11.976562 11.480469 C 11.976562 10.804688 12.527344 10.253906 13.203125 10.253906 C 14.101562 10.253906 14.832031 10.984375 14.832031 11.882812 C 14.832031 12.78125 14.101562 13.511719 13.203125 13.511719 Z M 13.203125 13.511719" />
              <path
                d="M 20.242188 12.785156 C 20.074219 12.660156 19.839844 12.695312 19.714844 12.859375 C 19.40625 13.273438 18.929688 13.511719 18.414062 13.511719 C 17.515625 13.511719 16.785156 12.78125 16.785156 11.882812 C 16.785156 10.984375 17.515625 10.253906 18.414062 10.253906 C 18.929688 10.253906 19.40625 10.492188 19.714844 10.90625 C 19.839844 11.074219 20.074219 11.105469 20.242188 10.980469 C 20.40625 10.855469 20.441406 10.621094 20.316406 10.457031 C 19.863281 9.851562 19.167969 9.503906 18.414062 9.503906 C 17.101562 9.503906 16.03125 10.570312 16.03125 11.882812 C 16.03125 13.195312 17.101562 14.261719 18.414062 14.261719 C 19.167969 14.261719 19.863281 13.914062 20.316406 13.3125 C 20.441406 13.144531 20.40625 12.910156 20.242188 12.785156 Z M 20.242188 12.785156" />
            </g>
          </svg>
        </button>

        <!-- sound record button -->
        <AudioRecords v-if="!chat_input" />

        <!-- send text message button -->
        <button v-if="chat_input" type="submit" @click="submit">
          <svg viewBox="0 0 80 80" style="width: 23px; fill: rgb(112, 112, 112);">
            <polygon id="Fill-1" fill="rgb(112 112 112)"
              transform="translate(59.841000, 39.746000) rotate(-90.000000) translate(-59.841000, -39.746000) "
              points="59.841 48.385 31.456 20 26 25.454 54.386 53.841 59.741 59.396 59.841 59.492 59.941 59.396 65.295 53.841 93.682 25.454 88.227 20">
            </polygon>
          </svg>
        </button>

        <!-- <button v-if="!chat_input && $store.state.config.storeId != 46" type="submit"  style="fill: rgb(112 112 112); visibility: hidden;">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z" /></svg>
      </button>  -->
      </div>
    </div>
  </div>
</template>

<script>
import { VEmojiPicker, emojisDefault, categoriesDefault } from "v-emoji-picker";
import Chat from "./Chat.vue"
import Search from "./Search.vue"
import specs from "@/specs"
import { customLogger } from "@/utils";

//Raw CSS because styling in Iframe does not work
//So we add it dynamically
import general from "!raw-loader!../assets/general.css";
import app from "!raw-loader!../assets/app.css";
import product_card from "!raw-loader!../assets/product_card.css";
import carousel from "!raw-loader!../assets/carousel.css";
import grid from "!raw-loader!../assets/grid.css";
import brands from "!raw-loader!../assets/brands.css";
import look from "!raw-loader!../assets/look.css";
import videoChatOverlay from "!raw-loader!../assets/VideoChatCss/video_chat_overlay.css";
import utils from '../utils'
import AppDisplay from './AppDisplay.vue';
import NavItems from './NavItems.vue';
import { apiRequest } from "@/services/api";
import store_utils from "@/store_utils";
import Virtual from './Virtual.vue'
import PoweredBy from "./PoweredBy.vue";
import VideoCall from './video/VideoCall.vue';
import VideoCallOverlay from './video/VideoChatOverlay.vue';
import AttachmentBox from "./AttachmentBox.vue";
import TimeTracker from './customs/TopBar_Formacast.vue'
import ProfilePage from './forms/ProfilePage_Formacast.vue'
import AudioRecords from "./customs/Audio_records.vue";
import Topbar_mfk from './customs/Topbar_mfk.vue';
import TopBarGenAi from "./customs/TopBar_genai.vue";


const getTextWidth = { canvas: null };

export default {
  components: {
    Chat,
    Search,
    VEmojiPicker,
    AppDisplay,
    NavItems,
    Virtual,
    VideoCall,
    VideoCallOverlay,
    PoweredBy,
    AttachmentBox,
    TimeTracker,
    ProfilePage,
    AudioRecords,
    Topbar_mfk,
    TopBarGenAi
  },
  data: () => {
    return {
      chat_input: "",
      settingsMenuOn: false,
      profilePageOn: false,
      write: false,
      inc: 1,
      close_icon: specs._CLOSE_ICON || 'close',
      no_chat: specs._NO_CHAT,
      //saveHeightTextArea: '56px',
      //search_mode: false
      showDialog: false,
      i18n: {
        search: 'emoji search...',
        categories: {
          Activity: "Atividades",
          Flags: "Bandeiras",
          Foods: "Comida",
          Frequently: "Frequentes",
          Objects: "Objetos",
          Nature: "Natureza",
          Peoples: "Pessoas",
          Symbols: "Símbolos",
          Places: "Locais"
        }
      }
    };
  },
  computed: {
    title() {
      if (this.$store.state.config.storeId == 59) {
        if (this.$store.state.user.page_title) {
          return this.$store.state.user.page_title;
        }
      }
      return {
        "style_profile": "text.shopper",
        "chat": "text.chat",
        "search": "text.searches",
        "app_mode": "text.app_mode",
        "info_mode": "text.info_mode",
        "whatsapp_mode": "text.whatsapp_mode",
        "your_mode": "text.your_mode",
        "rewards_mode": "text.rewards_mode",
        "live_shop_mode": "text.live_shop_mode",
        "product_s_mode": "text.product_s_mode",
        "filtered_s_mode": "text.filtered_s_mode",
        "visual_s_mode": "text.visual_s_mode",
        "3d_mode": "text.3d_mode",
        "size_mode": "text.size_mode",
        "live_assistant_mode": "text.live_assistant_mode",
        "virtual_t_on_mode": "text.virtual_t_on_mode"
      }[this.$store.state.navigation.mode]
    },
    navigation_mode() {
      customLogger("navigation_mode", this.$store.state.navigation.mode);
      return this.$store.state.navigation.mode
    },
    buttons_nav() {
      const data = this.$store.state.navigation.buttons_nav;
      return data;
    },
    chat_state() {
      const data = this.$store.state.config.chat_config.chat_state.state;
      return data;
    },
    genai_tabs() {
      const data = []
      if (this.$store.state.config.chatgpt) {
        if ([79].includes(this.$store.state.config.storeId)) {
          data.push({ name: 'chat.topbar_tabs.service_client', value: 'client_service' })
        } else if ([57].includes(this.$store.state.config.storeId)) {
          data.push({ name: 'chat.topbar_tabs.service_client', value: 'client_service' })
          data.push({ name: 'chat.topbar_tabs.products_assistance', value: 'get_products' })
        }
        this.$store.commit('SET_GENAI_MODE', 'client_service')
      }
      return data
    },
  },
  watch: {
    chat_state(curr_val, old_val) {
      this.removeTextArea(curr_val, this.$store.state.config.storeId);
    },
    chat_input(val, oldVal) {
      // #region emit taping indecator to admin side
      if (!val) this.input_blur();
      if (!this.write && val) {
        // customLogger("writing..");
        this.$eb.emit('ChatTrackingTyping', { state: "focus" });
        this.write = true;
      }
      //#endregion
      const iframe = document.getElementById("cleed-frame");
      const text = iframe.contentWindow.document.getElementById("chat-input");
      const bodyChat = iframe.contentWindow.document.getElementsByClassName('chat-box-body')[0]
      const chat_content = iframe.contentWindow.document.getElementsByClassName(
        "chat-content"
      )[0];
      const footer = iframe.contentWindow.document.getElementsByClassName(
        "chat-box-footer"
      )[0];

      if (val === "") {
        text.style.paddingTop = "5%";
        footer.style.maxHeight = "10%";
        bodyChat.style.height = 'calc(100% - 60px)'
        chat_content.style.height = "calc(100% - 7px)";
      } else {
        const sizeTextArea = text.offsetWidth - 129;
        const sizeText = this.getTextWidth(this.chat_input, null);
        const inc = Math.ceil(
          (sizeText > sizeTextArea ? sizeText : sizeTextArea) / sizeTextArea
        );

        if (this.inc != inc) {
          footer.style.height = footer.offsetHeight + inc * 10 + "px";
          this.inc = inc;

          // if (footer.offsetHeight + inc * 10 > 60)
          //   bodyChat.style.height = 'calc(100% - ' + footer.style.height + ')'
          // if (footer.offsetHeight + inc * 10 < 125 && sizeText < 195)
          //   footer.style.height = "80px";
        }
        //customLogger(sizeText);
        if (sizeText > 750) {
          chat_content.style.height = "calc(100% - 56px)";
          utils.scrollDown()
          footer.style.maxHeight = "20%";
        } else if (sizeText > 450) {
          chat_content.style.height = "calc(100% - 14px)";
          utils.scrollDown()
          footer.style.maxHeight = "16%";
        } else if (sizeText > 300) {
          chat_content.style.height = "calc(100% - 7px)";
          utils.scrollDown()
          footer.style.maxHeight = "13%";
        } else if (sizeText > 195) {
          text.style.paddingTop = "5%";
          footer.style.maxHeight = "10%";
        } else {
          text.style.paddingTop = "7%";
          footer.style.maxHeight = "10%";
          footer.style.height = "80px";
        }
      }
    },
    navigation_mode(curr_val, old_val) {
      //remove the text area when the navigation mode is style_profile
      if (curr_val == "style_profile") {
        this.removeTextArea("no-active")
      } else {
        this.removeTextArea('active')
      }
    },
  },
  mounted() {
    this.appendStyle();
    //remove the text area when the navigation mode is style_profile
    if (this.navigation_mode == "style_profile")
      this.removeTextArea("no-active")
    else
      this.removeTextArea(this.chat_state);
  },
  methods: {
    removeTextArea(state) {
      const iframe = document.getElementById("cleed-frame");
      const bodyChat = iframe.contentWindow.document.getElementsByClassName('chat-box-body')[0]
      if (!bodyChat) return
      if (this.$store.state.config.storeId == 33) {
        bodyChat.style.maxHeight = '85%'
        return
      }
      if (state == "no-active") {
        bodyChat.style.maxHeight = '80%'
      } else {
        if (this.$store.state.config.storeId == 59) {
          bodyChat.style.maxHeight = '65%'
          return
        }
        bodyChat.style.maxHeight = '70%'
      }
    },
    input_focus() {
      if (this.chat_input) {
        // customLogger("writing..");
        this.$eb.emit('ChatTrackingTyping', { state: "focus" });
        this.write = true
      }
    },
    input_blur() {
      // customLogger('end writing');
      this.$eb.emit('ChatTrackingTyping', { state: "blur" });
      this.write = false
    },
    appendStyle() {

      const iframe = document.getElementById("cleed-frame");
      const doc = iframe.contentWindow.document

      let app_style = doc.createElement("style");
      app_style.innerHTML = app;
      doc.body.appendChild(app_style);

      let product_card_style = doc.createElement("style");
      product_card_style.innerHTML = product_card;
      doc.body.appendChild(product_card_style);

      let carousel_style = doc.createElement("style");
      carousel_style.innerHTML = carousel;
      doc.body.appendChild(carousel_style);

      let grid_style = doc.createElement("style");
      grid_style.innerHTML = grid;
      doc.body.appendChild(grid_style);

      let brands_style = doc.createElement("style");
      brands_style.innerHTML = brands;
      doc.body.appendChild(brands_style);

      let video_chat_style = doc.createElement("style");
      video_chat_style.innerHTML = videoChatOverlay;
      doc.body.appendChild(video_chat_style);

      let look_style = doc.createElement("style");
      look_style.innerHTML = look;
      doc.body.appendChild(look_style);

      // custom style from the client
      let company_style = doc.createElement("style");
      company_style.innerHTML = this.$store.state.config.style;
      doc.body.appendChild(company_style);

      let general_style = doc.createElement("style");
      general_style.innerHTML = general;
      doc.head.appendChild(general_style);


      //force changing the font of html ,button ,textarea ,input ,a ,h3 ,pre to "Helvetica, sans-serif" iteratively
      if (this.$store.state.config.storeId == 59) {
        const elements = ["html", "button", "textarea", "input", "a", "h3", "pre"];
        elements.forEach((element) => {
          if (doc.querySelector(element))
            doc.querySelector(element).style.fontFamily = "Helvetica";
        });
      }



    },
    tracking(val) {
      if (val.trim().length)
        this.$eb.emit("ChatTrackingTyping", { showing: true })
      else
        this.$eb.emit("ChatTrackingTyping", { showing: false })
    },
    submit() {
      // customLogger('origin text:', this.chat_input);
      // customLogger('sanitize text:', utils.CleanTextEnterd(this.chat_input));
      this.chat_input = utils.CleanTextEnterd(this.chat_input)
      if (this.chat_input.trim().length) {
        this.$eb.emit("ChatSubmitMessage", this.chat_input, document.location.href)
      }
      this.chat_input = ''
    },
    onRestart() {
      this.$eb.emit("BoxRestartStyleProfile");
    },
    toggleAppVisibility() {
      this.$store.commit("RESET_QUIZ_OPTION");
      this.$store.commit("SET_STYLE_PROFILE_KEY", null);
      if (!this.$store.state.config.appIsVisible) {
        if (this.$store.state.session_navigation.modle3D) {
          this.$store.state.session_navigation.modle3D = !this.$store.state.session_navigation.modle3D
        }
        if (this.$store.state.session_navigation.virtual) {
          this.$store.state.session_navigation.virtual = !this.$store.state.session_navigation.virtual
        }
        this.$store.state.config.appIsVisible = !this.$store.state.config.appIsVisible
        this.change_mode('', 'app_mode')
      }
      if (this.$store.state.config.storeId == "49") {
        this.buttons_nav.stylePBC.bottom = "15px";
      }
    },
    display_settings() {
      this.settingsMenuOn = !this.settingsMenuOn
    },
    display_profile_page() {
      // customLogger('profilePageOn', this.profilePageOn)
      this.profilePageOn = !this.profilePageOn
      this.settingsMenuOn = false

      const iframe = document.getElementById("cleed-frame");
      const bodyChat = iframe.contentWindow.document.getElementsByClassName('chat-box-body')[0]
      if (!bodyChat) return

      bodyChat.style.display = this.profilePageOn ? 'none' : 'block'
    },
    getTextWidth(text, font) {
      const iframe = document.getElementById("cleed-frame");
      const doc = iframe.contentWindow.document
      // re-use canvas object for better performance
      var canvas =
        getTextWidth.canvas ||
        (getTextWidth.canvas = doc.createElement("canvas"));
      var context = canvas.getContext("2d");
      context.font = font;
      var metrics = context.measureText(text);
      return metrics.width;
    },
    change_mode(text = null, mode) {
      this.$eb.emit('BoxSwitchMode', { text, mode })
    },
    toogleDialogEmoji() {
      // customLogger("emoji Toogle!");
      this.showDialog = !this.showDialog;
    },
    onSelectEmoji(emoji) {
      this.chat_input += emoji.data;
      this.showDialog = !this.showDialog;
    },
    change_notif_mode() {
      this.$store.state.navigation.notificationSound = !this.$store.state.navigation.notificationSound;
    },
    change_notif_mode_dropdown() {
      this.$store.state.navigation.notificationSound = !this.$store.state.navigation.notificationSound;
      this.settingsMenuOn = !this.settingsMenuOn;
    },
    toogleAttachmentBox() {
      this.$store.dispatch("SET_ATTACH_BOX", {
        showing: true,
      });
    },
    log_out() {
      this.$store.dispatch("LOGOUT");
    }
  }
};
</script>